
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.977 22.672l10.625-10.625a1.867 1.867 0 012.648 0l1.766 1.765a1.867 1.867 0 010 2.649L31.492 24l7.531 7.531a1.867 1.867 0 010 2.649l-1.765 1.773a1.867 1.867 0 01-2.649 0L23.984 25.328a1.87 1.87 0 01-.007-2.656zm-15 2.656l10.625 10.625a1.867 1.867 0 002.648 0l1.766-1.766a1.867 1.867 0 000-2.648L16.492 24l7.531-7.531a1.867 1.867 0 000-2.649l-1.765-1.773a1.867 1.867 0 00-2.649 0L8.984 22.672a1.87 1.87 0 00-.007 2.656z","fill":"#535353"}})])
          )
        }
      }
    